module.exports = __webpack_public_path__ + "static/maze-ffb52917c0e359f5c80d9a15aadf195f.gif";